module.exports = __webpack_public_path__ + "img/plexus-6-small.a9618f7d.png";